import React from "react";

import classnames from "classnames";

type Props = {
  show: any;
  stayShown: boolean;
  children: React.ReactNode;
};
type State = {
  wasShown: boolean;
}; // Renders element only if this.props.show evaluates to true.
// Pass in stayShown={true} to always render element if initial condition was ever true.

export default class AppearingElement extends React.Component<Props, State> {
  static defaultProps = {
    stayShown: false,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      wasShown: false,
    };
  }

  // Watch show to flip wasShown to true

  /* eslint-disable no-unused-vars */
  componentWillReceiveProps(newProps: Props) {
    const { show, stayShown } = this.props;

    if (show && stayShown) {
      this.setState({
        wasShown: true,
      });
    }
  }

  /* eslint-enable no-unused-vars */
  // Does not render element when conditions not true, css className is for animation only
  render() {
    const { show, stayShown, children } = this.props;
    return (
      <div
        className={classnames("AppearingElement", {
          "AppearingElement--hidden": !show && !(stayShown && this.state.wasShown),
        })}
      >
        {show || (stayShown && this.state.wasShown) ? children : null}
      </div>
    );
  }
}
